import React, { createContext } from 'react'

export const NodesContext = createContext({
    nodes: [],
    audioList: [],
    apiPath: "",
    nodeConnections: {},
    setNodes: () => { },
    smsWebhookFlag: false,
    smsWebhookList: [],
    webhookList: [],
    apiWebhookList: [],
    updateNodeData: () => { },
    onRemove: () => { }
});